<template>
  <div class="cf-card cf-flex cf-flex--row cf-flex--align-start cf-flex--justify-space-between cf-flex--gap-16 cf-mobile-column">
    <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-16">
      <img
        v-if="dynamicContent.Receipt.metadata.signUpImageUrl"
        class="cf-image cf-image--logo-smallest"
        :alt="merchant.name"
        :src="dynamicContent.Receipt.metadata.signUpImageUrl"
        onerror="this.src='/images/image-not-found.png';"
      >

      <div class="cf-flex cf-flex--column cf-flex--align-start cf-flex--gap-12">
        <h3 class="cf-title cf-title--3">
          {{ dynamicContent.Receipt.metadata.signUpTitle }}
        </h3>

        <p class="cf-subtitle cf-subtitle--2">
          {{ dynamicContent.Receipt.metadata.signUpDescription }}
        </p>
      </div>
    </div>

    <button
      class="cf-button cf-button--primary cf-button--md cf-button--mobile-fill cf-align-self-center"
      type="button"
      @click="createAccountHandler"
    >
      {{ dynamicContent.Receipt.metadata.signUpButtonCta }}
    </button>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import events from '@/services/events';


  export default {
    name: 'ReceiptCreateAccountCta',

    props: {
      receipt: {
        type: Object,
        required: true
      }
    },

    computed: {
      ...mapGetters('content', ['dynamicContent']),
      ...mapGetters('merchant', ['loyaltyOptions', 'merchant'])
    },

    methods: {
      createAccountHandler() {
        if (this.loyaltyOptions.loyaltyEnrollmentEnabled) {
          events.emit('enroll-in-loyalty:open', {
            forceOpen: true,
            skipInitialContent: true
          });
        }

        else {
          this.$openModal('createAccount');
        }
      }
    }
  };
</script>
